import axios from "../utils/axios";


let productApi = {
   getProfile: () => axios({
      url: '/v1/admin/profile',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   addProduct: (data) => axios({
      url: '/v1/admin/product',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateProduct: (data) => axios({
      url: '/v1/admin/product',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getProducts: (page = 1) => axios({
      url: `/v1/admin/products?page=${page}&limit=10`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getOrders: (page = 1) => axios({
      url: `/v1/admin/orders?page=${page}&limit=10`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getOrderDetails: (id = 1) => axios({
      url: `/v1/admin/order/${id}`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getUserOrders: (id, page = 1) => axios({
      url: `/v1/admin/user/${id}/orders?page=${page}&limit=10`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getUserDetails: (id) => axios({
      url: `/v1/admin/user/${id}`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getUsers: (page = 1) => axios({
      url: `/v1/admin/users?page=${page}&limit=10`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   contactUsList: (page = 1) => axios({
      url: `/v1/admin/contact-us?page=${page}&limit=10`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateProductsListOrder: (data) => axios({
      url: '/v1/admin/product-order',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getLocations: () => axios({
      url: '/v1/admin/location',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
}

export default productApi
